<template>
  <div v-loading.fullscreen.lock="this.getImageViewerURL == ''" class="imageContainer">
    <img v-show="this.getImageViewerURL != ''" :src="this.getImageViewerURL" @error="replaceByDefault">
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import error_image from "../../assets/image/errorImage.png";
export default {
  name: 'Image',
  computed: {
    ...mapGetters("sp_Situation0008", [
        "getImageViewerURL",
    ]),
	},methods: {
    replaceByDefault(event) {
      event.target.src = error_image;
    },
  },
  mounted(){
    let articleId = this.$route.query.article_id;
    let serialNo = this.$route.query.serial_no;
    if(articleId != null && articleId != '' && serialNo != null && serialNo != '') {
      var inputParam = {
        article_id: articleId,
        serial_no: serialNo
      }
      this.$store.dispatch('sp_Communication0008/getSCArticleBigImage', inputParam).then(() => {
        this.fullscreenLoading = false;
      }).catch(() => {
        this.fullscreenLoading = false;
      })
    }
    else{
      this.$store.commit('sp_Situation0008/setImageViewerURL', "error", { root: true });
    }
  }
}
</script>

<style>
body, html {
  height: 100%;
  background-color: #000;
}
#app {
  width: 100%;
  height: 100%;
}
.imageContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imageContainer img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>